import React from "react";

import Footer from "../index/Footer.jsx";

class Privacy extends React.Component {
  render() {
    return (
      <>
        {/* <DefaultNavbar useOnlyDarkLogo={true} /> */}
        <main ref='main'>
          <div className='container'>
            <h2>Morph Privacy Policy</h2>
            <p>
              Morph is an augmented reality app developed by Morph Studios, a
              Qmulo, Inc. company. This policy describes what information the
              Morph app collects, how it is used, and the choices you have. It
              applies to the Morph mobile app and the Morph websites
              (morphxr.io and morphxr.app).
            </p>

            <h3>Information We Collect</h3>
            <h5>Account information</h5>
            <p>
              When you create a Morph account you can sign up with Apple,
              Google, or an email address and password. Depending on the method
              you choose, we collect your email address, your name, and the
              username and profile photo you set. We never see or store your
              Apple or Google password.
            </p>
            <h5>Content you create</h5>
            <p>
              Photos you upload, AR placements you create, and direct messages
              you send through Morph are stored on our servers so we can
              deliver them to you and the people you share them with.
            </p>
            <h5>Location</h5>
            <p>
              With your permission, Morph uses your device's location while you
              are using the app to unlock geo-fenced AR experiences and to
              understand engagement with location-based content. Engagement
              data is anonymized and used only for app insights. We do not
              track your location in the background, and we do not share your
              location with third-party advertisers.
            </p>
            <h5>Device and diagnostic information</h5>
            <p>
              If the app crashes or encounters an error, we collect diagnostic
              information such as your device model, operating system version,
              app configuration, and the time and date of the error. We also
              generate a random identifier for your installation so features
              like shared links work before you sign in; it is not tied to your
              identity.
            </p>
            <h5>Purchases</h5>
            <p>
              In-app purchases and subscriptions are processed by Apple or
              Google together with our subscription partner RevenueCat. We
              receive a record of your purchase but never your payment card
              details.
            </p>

            <h3>Third-Party Services</h3>
            <p>
              Morph relies on a small number of service providers to operate
              the app. Each processes data only to provide its service to us:
            </p>
            <p>
              <a href='https://policies.google.com/privacy'>
                Google Firebase
              </a>{" "}
              (push notifications and crash reporting),{" "}
              <a href='https://www.revenuecat.com/privacy'>RevenueCat</a>{" "}
              (in-app purchases),{" "}
              <a href='https://www.mapbox.com/legal/privacy'>Mapbox</a>{" "}
              (converting coordinates to place names), and{" "}
              <a href='https://www.ptc.com/en/documents/policies/privacy'>
                PTC Vuforia
              </a>{" "}
              (augmented reality engine).
            </p>
            <p>
              We do not sell your personal information, and Morph does not
              include third-party advertising networks. On iOS, Morph asks for
              tracking permission through Apple's App Tracking Transparency
              prompt; you can decline without losing any functionality.
            </p>

            <h3>Push Notifications</h3>
            <p>
              With your permission, we send push notifications about activity
              relevant to you. You can turn these off at any time in your
              device settings.
            </p>

            <h3>Your Choices</h3>
            <p>
              Camera, photo library, location, and notification access are all
              optional and can be revoked in your device settings. In the app
              you can control who is able to send you direct messages, and you
              can permanently delete your account and its associated data from
              Profile Settings. You can also email us to request deletion of
              your data.
            </p>

            <h3>Data Security</h3>
            <p>
              Sign-in credentials are stored in your device's secure keychain,
              and communication with our servers is encrypted in transit. We
              take reasonable measures to protect your information, though no
              security system is infallible.
            </p>

            <h3>Children's Privacy</h3>
            <p>
              Morph is not directed at children. You must be at least 13 years
              old (or the minimum legal age in your jurisdiction) to create an
              account, and we do not knowingly collect personal information
              from children.
            </p>

            <h3>Links to Other Sites</h3>
            <p>
              This Service may contain links to other sites. If you click on a
              third-party link, you will be directed to that site. Note that
              these external sites are not operated by us. Therefore, we
              strongly advise you to review the Privacy Policy of these
              websites. We have no control over and assume no responsibility for
              the content, privacy policies, or practices of any third-party
              sites or services.
            </p>

            <h3>Changes to This Privacy Policy</h3>
            <p>
              We may update our Privacy Policy from time to time. Thus, you are
              advised to review this page periodically for any changes. We will
              notify you of any changes by posting the new Privacy Policy on
              this page. These changes are effective immediately after they are
              posted on this page.
            </p>

            <h3>Contact Us</h3>
            <p>
              If you have any questions or suggestions about our Privacy
              Policy, or want to exercise any of the choices above, contact us
              at{" "}
              <a href='mailto:support@morphxr.app'>support@morphxr.app</a> or{" "}
              <a href='mailto:contact@morphxr.io'>contact@morphxr.io</a>.
            </p>

            <p>Last Updated 08/28/2026</p>
          </div>
        </main>

        <Footer />
      </>
    );
  }
}

export default Privacy;
